module.exports = __webpack_public_path__ + "img/5-5.f5fe03bf.svg";